/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedRecentHistoryTracker_item = {|
  +serviceId: ?string;
  +title: ?string;
  +firstPhotoWebPath: ?string;
  +pdpURL: ?string;
  +contemporaryTrackingString: string;
  +categoryPath: ?string;
  +isComplete: ?boolean;
  +isListingListed: ?boolean;
  +seller: ?{|
    +serviceId: ?string;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRecentHistoryTracker_item",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "title",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small",
          "type": "ImageVersionTypeName!"
        }
      ],
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath{\"size\":\"small\"}"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "contemporaryTrackingString",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "categoryPath",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isComplete",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isListingListed",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
